
import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { useUserProfilesData } from "@/hooks/dashboard/useUserProfilesData";
import UserProfilesHeader from "./users/UserProfilesHeader";
import UserProfilesLoadingState from "./users/UserProfilesLoadingState";
import UserProfilesEmptyState from "./users/UserProfilesEmptyState";
import UserList from "./users/UserList";
import UserProfileDialog from "@/components/profile/UserProfileDialog";

const UserProfiles = () => {
  const { 
    users, 
    loading, 
    followingMap, 
    user: currentUser,
    handleFollow, 
    handleMessage,
    handleViewProfile,
    fetchUsers 
  } = useUserProfilesData();

  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [showProfileDialog, setShowProfileDialog] = useState(false);

  const onViewProfile = (userId: string) => {
    setSelectedUserId(userId);
    setShowProfileDialog(true);
  };

  return (
    <>
      <Card className="p-6 bg-card rounded-lg shadow-sm border">
        <UserProfilesHeader />

        {loading ? (
          <UserProfilesLoadingState />
        ) : users.length > 0 ? (
          <UserList 
            users={users}
            followingMap={followingMap}
            currentUser={currentUser}
            onFollow={handleFollow}
            onMessage={handleMessage}
            onViewProfile={onViewProfile}
            onRefresh={fetchUsers}
          />
        ) : (
          <UserProfilesEmptyState onRefresh={fetchUsers} />
        )}
      </Card>

      <UserProfileDialog 
        userId={selectedUserId}
        open={showProfileDialog}
        onClose={() => {
          setShowProfileDialog(false);
          setSelectedUserId(null);
        }}
      />
    </>
  );
};

export default UserProfiles;
